import { call, put } from 'redux-saga/effects';
import GetMakeUpSessionActions from '../redux/GetMakeUpSessionRedux';
import { api } from './api';


export function* getmakeupsessionsagas(action: any): Generator<any, void, any> {
  const { children_id } = action;
  const response = yield call(api.getMakeUpSession, children_id);

  console.log("response", response, api.getMakeUpSession);
  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(
      GetMakeUpSessionActions.getMakeUpSessionSuccess(response.data?.data)
    );
  } else {
    yield put(GetMakeUpSessionActions.getMakeUpSessionFailure());
  }
}